<template>
  <div class="modify-password">
    <div class="setting-title">基本信息</div>
    <el-form
      :rules="rules"
      :model="form"
      label-position="top"
      ref="passwordForm"
    >
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input
          placeholder="请输入旧密码"
          v-model="form.oldPassword"
          style="width: 2.8rem"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input
          placeholder="请输入新密码"
          v-model="form.newPassword"
          style="width: 2.8rem"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="newPasswordOnce">
        <el-input
          placeholder="确认密码"
          v-model="form.newPasswordOnce"
          style="width: 2.8rem"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="confirm">
      <div class="confirm-btn" @click="modifyPassword">保存</div>
    </div>
  </div>
</template>
  
  <script>
import { getPublicKey, updatePassword } from "@/api/user";
import { Md5 } from "@/utils";
import jsencrypt from "jsencrypt";
import { forgetPassword } from "@/config";

export default {
  data() {
    //两次密码不一致
    let repeat = (rule, value, callback) => {
      if (this.form.newPassword != value || !this.form.newPassword) {
        return callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        newPasswordOnce: "",
      },
      rules: {
        ...forgetPassword,
        newPasswordOnce: [
          {
            require: true,
            min: 6,
            max: 18,
            message: "请设置6-18位字符，需同时包含数字、字母",
            trigger: "blur",
          },
          { validator: repeat },
        ],
      },
    };
  },
  methods: {
    modifyPassword() {
      this.$refs["passwordForm"].validate(async (valid) => {
        if (valid) {
          const phone = this.$store.state.userInfo.phone;
          const publicKey = await getPublicKey({ phone });
          const encrypt = new jsencrypt();
          encrypt.setPublicKey(publicKey);
          const oldPassword = encrypt.encrypt(Md5(this.form.oldPassword));
          const newPassword = encrypt.encrypt(Md5(this.form.newPassword));
          const newPasswordOnce = encrypt.encrypt(
            Md5(this.form.newPasswordOnce)
          );
          updatePassword({
            oldPassword,
            newPassword,
            newPasswordOnce,
          }).then(() => {
            this.$message({
              type: "success",
              message: "修改成功",
            });
            this.$refs.passwordForm.resetFields();
          });
        }
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.modify-password {
  :deep(.el-form-item) {
    font-size: 0.16rem;
    margin-bottom: 0.14rem;
  }
  :deep(.el-form-item__label) {
    padding-bottom: 0;
    font-size: 0.16rem;
    &::before {
      display: none;
    }
  }
  .setting-title {
    font-size: 0.18rem;
    font-weight: bold;
    margin-bottom: 0.1rem;
  }
  .confirm {
    width: 2.8rem;
    margin-top: 0.4rem;
    display: flex;
    justify-content: center;
    .confirm-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.64rem;
      height: 0.47rem;
      background-color: #007eff;
      color: #fff;
      font-size: 0.16rem;
      cursor: pointer;
    }
  }
}
</style>